import { getAuthToken } from './trpc';

interface UploadResult {
  url: string;
  key: string;
  nome: string;
  tipo: string;
}

export async function uploadFile(file: File): Promise<UploadResult> {
  const token = getAuthToken();
  if (!token) throw new Error('Não autenticado');

  const formData = new FormData();
  formData.append('file', file);

  const baseUrl = import.meta.env.VITE_API_URL || '';
  const res = await fetch(`${baseUrl}/upload`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || 'Erro ao enviar arquivo');
  }

  return data as UploadResult;
}
